"use client";

import { useEffect } from "react";

/**
 * Applies the resolved per-tenant locale to `<html lang>` from the client.
 *
 * The root layout is a static shell (Task 5D-1) so it can only SSR a static
 * `lang="en"`; a static parent cannot render the tenant's locale onto the
 * `<html>` element it owns. `<DynamicTenantShell>` (and, from Task 5D-2, the
 * `sites` layout) resolves the real locale below that boundary and mounts
 * this setter, which writes `document.documentElement.lang` after hydration.
 *
 * Runs post-hydration only, so there is no SSR/client mismatch on `<html>`
 * (server and client both start at `lang="en"`, then this updates it).
 */
export function HtmlLang({ locale }: { locale: string }): null {
  useEffect(() => {
    if (locale) document.documentElement.lang = locale;
  }, [locale]);
  return null;
}
